import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import type { ProductTypeId } from '../types';

const FIELD_LABELS: Record<ProductTypeId, string> = {
  Accommodation: 'Product Type : Accommodation',
  AddOn: 'Product Type : AddOns',
  Course: 'Product Type : Course',
  Fees: 'Product Type : Standard Fees',
  Package: 'Product Type : Packages',
  Transfer: 'Product Type : Transfer',
};

interface FieldLibraryCardProps {
  productType: ProductTypeId;
  disabled?: boolean;
}

export const FieldLibraryCard: React.FC<FieldLibraryCardProps> = ({ productType, disabled }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `field-${productType}`,
    data: { productType, source: 'field-library' },
    disabled: !!disabled,
  });

  const style = transform
    ? { transform: CSS.Translate.toString(transform), opacity: isDragging ? 0.5 : 1 }
    : undefined;

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...(disabled ? {} : listeners)}
      {...(disabled ? {} : attributes)}
      className={`commission-field-library-card${disabled ? ' commission-field-library-card--disabled' : ''}`}
    >
      <div className="commission-field-label">{FIELD_LABELS[productType]}</div>
      <div className="commission-field-sub">Specify product</div>
    </div>
  );
};

interface FieldLibraryProps {
  onCardClick?: (productType: ProductTypeId) => void;
  disabledProductTypes?: ReadonlySet<ProductTypeId>;
}

export const FieldLibrary: React.FC<FieldLibraryProps> = ({ disabledProductTypes }) => {
  const order: ProductTypeId[] = ['Course', 'Accommodation', 'AddOn', 'Transfer', 'Fees', 'Package'];

  return (
    <div className="commission-field-library">
      <div className="commission-field-library-title">Field Library</div>
      {order.map((pt) => (
        <FieldLibraryCard key={pt} productType={pt} disabled={disabledProductTypes?.has(pt)} />
      ))}
    </div>
  );
};